import { render, staticRenderFns } from "./TheMarketplaceForm.vue?vue&type=template&id=5b33d907"
import script from "./TheMarketplaceForm.vue?vue&type=script&lang=js"
export * from "./TheMarketplaceForm.vue?vue&type=script&lang=js"
import style0 from "./TheMarketplaceForm.vue?vue&type=style&index=0&id=5b33d907&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports